import React from "react";
import Roadshow from "./RoadshowList/Roadshow";

const RoadshowOperation = () => {
    return <Roadshow type="list" title="Roadshow list" />;
};

export default RoadshowOperation;
